export enum TypeChauffageEnum {
  CombustibleGaz = 'Combustible Gaz',
  CombustibleFioul = 'Combustible Fioul',
  Charbon = 'Charbon',
  Bois = 'Bois',
  Electrique = 'Electrique',
  PompeChaleur = 'Pompe à chaleur',
  Geothermie = 'Géothermie',
  Solaire = 'Solaire (Biomasse)',
  Granules = 'Granulés (Biomasse)',
  ChaleurENRMaj = 'Réseau de chaleur ENR >50%',
  ChaleurENRMin = 'Réseau de chaleur ENR <= 50%',
  PompeChaleurGaz = 'Pompe à chaleur + chaudière gaz',
  PompeChaleurFioul = 'Pompe à chaleur + chaudière fioul',
  PompeChaleurCharbon = 'Pompe à chaleur + chaudière charbon',
  ChaudiereBiomasseGaz = 'Chaudière biomasse + chaudière gaz',
  ChaudiereBiomasseFioul = 'Chaudière biomasse + chaudière fioul',
  ChaudiereBiomasseCharbon = 'Chaudière biomasse + chaudière charbon',
}
